import servise from '@/router/axios'

// 查询角色管理列表
export const fetchList = (data) => {
  return servise({
    url: '/sysUserRole/manage/list',
    method: 'get',
    data
  })
}

// 获取角色权限选择列表
export const sysUserRoleMenuList = (params) => {
  return servise({
    url: '/sysUserRole/menu/list',
    method: 'get',
    params
  })
}

// 获取角色权限列表
export const sysUserRoleRoleMenuList = (params) => {
  return servise({
    url: '/sysUserRole/role/menu/list',
    method: 'get',
    params
  })
}

// 修改当前角色状态
export const updateStatus = (data) => {
  return servise({
    url: '/sysUserRole/update/status',
    method: 'PUT',
    data
  })
}

// 新添角色
export const addSysUserRole = (data) => {
  return servise({
    url: '/sysUserRole/add',
    method: 'post',
    data
  })
}

// 修改当前角色信息
export const updateSysUserRole = (data) => {
  return servise({
    url: '/sysUserRole/update',
    method: 'PUT',
    data
  })
}
